module.exports = __webpack_public_path__ + "static/media/img-about-usp3@2x.3e78ceae.jpg";